export const PrimaryButtonStyle:React.CSSProperties = {
  display: "flex",
  height: "48px",
  padding: "12px 32px",
  justifyContent: "center",
  alignItems: "center",
  gap: "4px",
  borderRadius: "25px",
  border: "1px solid #0061A0",
  background:"#FFFFFF",
  color: "#0061A0",
  textAlign: "center",
  fontFeatureSettings: "'clig' off, 'liga' off",
  fontFamily: "FS Elliot Pro Bold",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "700",
  lineHeight: "21px"
}

export const PrimaryDisabledButtonStyle:React.CSSProperties = {
  display: "flex",
  height: "48px",
  padding: "12px 32px",
  justifyContent: "center",
  alignItems: "center",
  gap: "4px",
  borderRadius: "25px",
  border: "1px solid #0061A0",
  background:"#929ea6",
  color: "#FFF",
  textAlign: "center",
  fontFeatureSettings: "'clig' off, 'liga' off",
  fontFamily: "FS Elliot Pro Bold",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "700",
  lineHeight: "21px"
}

export const SecondaryButtonStyle:React.CSSProperties = {
  height: "48px",
  padding: "12px 32px",
  justifyContent: "center",
  alignItems: "center",
  gap: "4px",
  borderRadius: "25px",
  background: "#0061A0",
  color: "#FFF",
  textAlign: "center",
  fontFamily: "FS Elliot Pro Bold",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "700",
  lineHeight: "21px",
}
export const SecondaryButtonDisabledStyle:React.CSSProperties = {
  height: "48px",
  padding: "12px 32px",
  justifyContent: "center",
  alignItems: "center",
  gap: "4px",
  borderRadius: "25px",
  background: "#929ea6",
  color: "#FFF",
  textAlign: "center",
  fontFamily: "FS Elliot Pro Bold",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "700",
  lineHeight: "21px",
}

export const CloseButtonStyle:React.CSSProperties = {
  display: "flex",
  padding: "6px",
  alignItems: "flex-start",
  gap: "4px",  
  borderRadius: "100px",
  border: "1px solid rgba(51, 51, 51, 0.00)",
  background: "rgba(51, 51, 51, 0.00)",
  marginLeft:"auto"
}